import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./TabBar.css";

/**
 * TabBar — VS Code-style editor tab strip.
 * Active tab shown with white top border and full background.
 */
const TABS = [
  { path: "/portfolio",         label: "index.js",    icon: "js" },
  { path: "/portfolio/projects", label: "projects.js", icon: "js" },
  { path: "/portfolio/about",    label: "about.js",    icon: "js" },
];

const TAB_COLORS = { react: "#61dafb", js: "#f7df1e" };

function TabBar() {
  const location = useLocation();

  return (
    <div className="tab-bar">
      <div className="tab-bar__tabs">
        {TABS.map((tab) => {
          const isActive =
            tab.path === "/portfolio"
              ? location.pathname === "/portfolio"
              : location.pathname.startsWith(tab.path);

          return (
            <NavLink
              key={tab.path}
              to={tab.path}
              end={tab.path === "/"}
              className={`tab${isActive ? " tab--active" : ""}`}
            >
              <span
                className="tab__dot"
                style={{ color: TAB_COLORS[tab.icon] }}
              >●</span>
              <span className="tab__label">{tab.label}</span>
              <button
                className="tab__close"
                onClick={(e) => e.preventDefault()}
                aria-label="Close tab"
              >×</button>
            </NavLink>
          );
        })}
      </div>

      {/* Breadcrumb */}
      <Breadcrumb pathname={location.pathname} />
    </div>
  );
}

function Breadcrumb({ pathname }) {
  const parts = pathname === "/portfolio" ? ["index.js"] : pathname.split("/").filter((p) => p !== "portfolio").filter(Boolean);
  return (
    <div className="breadcrumb">
      <span className="breadcrumb__item">src</span>
      <span className="breadcrumb__sep">›</span>
      <span className="breadcrumb__item">pages</span>
      {parts.map((p, i) => (
        <React.Fragment key={i}>
          <span className="breadcrumb__sep">›</span>
          <span className="breadcrumb__item">
            {p.includes(".") ? p : `${p}.js`}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
}

export default TabBar;
